function posFeaturePayAtTable(integrationConstant, integrationSettingsService, integrationViewService,
                              gettextCatalog) {
    const vm = this;
    const manageDisplay = () => {
        // Integration type(pos,fulfilment)
        const parentComponentRules = vm.mapVisibleFeature;
        const actions = {
            payAtTable: vm.data.payAtTable,
            orderAtTable: vm.data.orderAtTable
        };
        const externalImpact = {
            parentComponentRules,
            siblingsComponent: actions,
            parentData: vm.parentData || null,
            isUseMerchantSettings: vm.data.isUseMerchantSettings
        };
        vm.visible = integrationViewService.getPayAtTableDisplay(externalImpact);
    };
    const commonUpdate = () => {
        vm.onDataUpdate({updatedData: vm.data});
        manageDisplay();
    };
    const manageInitialState = () => {
        vm.initialStateData = {
            toggle: vm.data.payAtTable,
            posType: vm.data.posType
        };
    };
    vm.RADIO_YES = integrationConstant.VIEW_SETTINGS.RADIO_YES;
    vm.RADIO_NO = integrationConstant.VIEW_SETTINGS.RADIO_NO;
    vm.FEATURES = {
        payAtTable: {
            label: gettextCatalog.getString('Pay at Table')
        }
    };
    vm.updateTogglePayAtTable = () => {
        vm.toggleSet.payAtTable = vm.data.payAtTable;
        vm.onToggleUpdate({toggleSet: vm.toggleSet});
        commonUpdate();
        manageInitialState();
        // need to be after onDataUpdate
        vm.onToggleCleanSubFeature({data : {value: vm.data.payAtTable, type: 'pat'}});
    };
    vm.updatePayAtTable = () => {
        commonUpdate();
    };
    vm.$onInit = () => {
        // set values, given better names for simplicity
        vm.data = integrationSettingsService.merge({}, vm.integrationData);
        manageInitialState();
        manageDisplay();

    };
    vm.$onChanges = (changesObj) => {
        // Changes in the integrationData on the parent needs to be update
        if (changesObj.integrationData) {
            vm.data = integrationSettingsService.merge({}, changesObj.integrationData.currentValue);
            manageInitialState();
            manageDisplay();
        }
        // trigger after change useMerchantSettings for outlet
        if (changesObj.mapVisibleFeature) {
            vm.mapVisibleFeature = changesObj.mapVisibleFeature.currentValue;
            manageDisplay();
            manageInitialState();
        }
    };
}
angular.module('qkr.integration.settings')
    .component('payAtTable', {
        template: require('./pay-at-table.html'),
        bindings: {
            integrationData: '<',
            parentData: '<?',
            integrationForm: '<',
            mapVisibleFeature: '<',
            toggleSet: '<',
            location: '<',
            onDataUpdate: '&',
            onToggleUpdate: '&',
            onToggleCleanSubFeature: '&'
        },
        controller: posFeaturePayAtTable,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./src/integration-settings/components/children-components/types/pos-feature/pay.at.table.component.js